import Vue from 'vue'
import App from './App.vue'
import store from '@/store'
import Vuelidate from 'vuelidate'
import router from './router'
import '@/moduleRoute'
import '@/assets/css/scenario.css'
import '@/assets/css/needs.css'
import VueTippy, { TippyComponent } from "vue-tippy";

window.store = store;

router.beforeEach((to, from, next) => {
    if (from.name === 'needs_analysis') {
        let defaultShow = {
            retire_1: true,
            retire_2: false,
            retire_3: false,
            retire_4: false,
            retire_5: false,
            retire_form: false,
        }
        store.dispatch('retire/defaultShow', defaultShow).then()
    }
    window.document.title = `${to.meta.title} | 買保險 SmartBeb`;
    next();
})

Vue.use(Vuelidate)

Vue.use(VueTippy);


const vm = new Vue({
    router,
    store,
    render: h => h(App),
    mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount('#app')

window.vm = vm; //vue 把组件方法暴露到window对象中
